/* IMPORTANT */
// Not use on any component in the BEFORECREATED statement
// Order ALPHABETICALLLY
import xMiscService from '@/services/xMiscService'
export const xMisc = {
  data () {
    return {
      googleSignInParams: {
        client_id: '1042038851656-uhm0ve8diat0fblalc9lfdivqmkueib2.apps.googleusercontent.com'
      },
      xCompany: ''
    }
  },
  methods: {
    alert (type, message) {
      this.$snackbar.open({
        duration: 5000,
        message: message,
        type: 'is-' + type,
        position: 'is-top',
        actionText: 'Ok',
        queue: false
      })
    },
    getUrlQuery () {
      if (this.$route.query.c) {
        this.xCompany = this.$route.query.c
        this.vCompany()
      }
    },
    googleSignInSuccess (googleUser) {
      var profile = googleUser.getBasicProfile()
      console.log(profile)
    },
    googleSignInError (error) {
      this.alert('danger', error)
    },
    goTo (location) {
      this.$router.push('/' + location)
    },
    logout () {
      this.$session.destroy()
      location.href = '/login'
    },
    start () {
      this.$Progress.start()
    },
    stop () {
      this.$Progress.fail()
      this.$Progress.finish()
    },
    ucwords (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    // empty array
    clearArray (variable) {
      var s = variable.length
      for (var i = s - 1; i >= 0; i--) {
        variable.splice(i, 1)
      }
    },
    urlParse (string) {
      var s = string.trim()
      var url = s.replace(/\s+/g, '-').toLowerCase()
      return url
    },
    async vCompany () {
      var r = await xMiscService.verifyCompany({url: this.xCompany})
      if (r.data.response != null) {
        this.$session.set('i', r.data.response._id)
      }
    },
    vLength (c, string) {
      var response = true
      if (string.length < c.min) {
        response = false
        this.alert('danger', 'Debes incluir mas de 3 caracteres')
      }
      if (string.length > c.max) {
        response = false
        this.alert('danger', 'No puedes superar mas de 15 caracteres')
      }
      return response
    },
    vSession () {
      if (this.$session.has('user')) {
        location.href = 'home'
      } else {
        if (this.$route.path !== '/login') {
          location.href = 'login'
        }
      }
    },
    vSpecialChars (string) {
      var response = false
      var regex = /[!@#$%^&*(),.?":{}|<>]/g
      if (string.match(regex)) {
        response = true
      } else {
        response = false
      }
      return response
    },
    vlUser () {
      if (this.$session.has('user')) {
        var user = this.$session.get('user')
        if (user) {
          console.log(user)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/xMisc.js